import React from 'react';
import classNames from 'classnames';
import './Arrow.scss';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {regular} from '@fortawesome/fontawesome-svg-core/import.macro';

interface ArrowProps {
  onArrowClick: () => void;
  isNext?: boolean;
  className?: string;
  furtherTabsCount?: number;
}

export const Arrow: React.FC<ArrowProps> = ({ isNext, className, onArrowClick, furtherTabsCount = 0 }) => {
  return (
    <button
      className={classNames('tabs-bar-arrow__wrapper', className, {
        'tabs-bar-arrow__wrapper--next': isNext,
        'tabs-bar-arrow__wrapper--inactive': furtherTabsCount <= 0,
      })}
      onClick={onArrowClick}
    >
      <FontAwesomeIcon icon={isNext ? regular('chevron-double-right') : regular('chevron-double-left')} size="lg" />
      <span className="tabs-bar-arrow__label">{furtherTabsCount}</span>
    </button>
  );
};
